import styled from "styled-components";
import { IconButton as MuiIconButton, TableCell } from "@mui/material";
import { ArrowBack as MuiArrowBack } from "@mui/icons-material";

export const Loading = styled.div`
  padding: 1rem 1.25rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
`;

export const Container = styled.div`
  padding: 1rem 1.25rem;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 0.25rem;
  align-items: center;
  padding: 0.5rem 0;
  margin-top: 24px;
`;

export const Cell = styled(TableCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: "300px";
`;







export const Main = styled.div`
  width: 100%;
  max-width: 1366px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
`;

const getColor = (props: any) => {
  if (props.isDragAccept) {
      return '#00e676';
  }
  if (props.isDragReject) {
      return '#ff1744';
  }
  if (props.isFocused) {
      return '#2196f3';
  }
  return '#3024E1';
}

export const UploadContainer = styled.div`
flex: 1;
display: flex;
flex-direction: column;
align-items: center;
margin: 20px 0;
padding: 20px;
border-width: 2px;
border-radius: 12px; /* más redondeado */
cursor: pointer;
background-color: #fff;
color: #7C3AED;
outline: none;
transition: border 0.24s ease-in-out;
background-image: url("data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%233024E180' stroke-width='5' stroke-dasharray='12%2C12' stroke-linecap='round'/%3E%3C/svg%3E");


`;

export const ArrowBack = styled(MuiArrowBack)`
  width: 24px;
  height: 24px;
`;
export const IconButton = styled(MuiIconButton)`
  margin-bottom: 2px;
`;